const reviewApproverTypeConstants = Object.freeze({
  ANY_ADMIN: 'any_admin',
  AUTO_APPROVAL: 'auto_approval'
});

const reviewStatusConstants = Object.freeze({
  APPROVED: 'approved',
  REJECTED: 'rejected',
  PENDING: 'pending',
  DEFAULT: 'default',
  AUTO_APPROVAL: 'auto-approval'
});

export {
  reviewApproverTypeConstants,
  reviewStatusConstants,
};

